<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-lightbulb heroicon heroicon-sm"
  >
    <path
      class="heroicon-lightbulb-bulb heroicon-component-fill"
      fill="#FFFFFF"
      d="M34 41.62c.83-.16 1.65-.37 2.45-.63a4 4 0 0 0-.45 1.84V46H24v-3.17a4 4 0 0 0-.45-1.84c.8.26 1.62.47 2.45.63v-2.04A18.98 18.98 0 0 1 11 21a19 19 0 1 1 23 18.58v2.04z"
    ></path>
    <path
      class="heroicon-lightbulb-screw heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M25 53v-1h-.5a1.5 1.5 0 0 1 0-3h.5v-2h10v2h.5a1.5 1.5 0 0 1 0 3H35v1h.5a1.5 1.5 0 0 1 0 3H35v2l-4 1h-2l-4-1v-2h-.5a1.5 1.5 0 0 1 0-3h.5z"
    ></path>
    <path
      class="heroicon-lightbulb-source heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M28 38a2 2 0 0 1 2-2 2 2 0 0 1 2 2v10h-4V38z"
    ></path>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M47.24 32.99A18.93 18.93 0 0 0 48.9 23a19 19 0 0 1-37.8 0 19.22 19.22 0 0 0 1.66 9.99 21.11 21.11 0 0 0 5.95 5.72l2.7 2.7a2 2 0 0 1 .49.78 18.93 18.93 0 0 0 16.2 0 2 2 0 0 1 .49-.78l2.7-2.7a21.11 21.11 0 0 0 5.95-5.72zM25 47h10v2H25v-2zm0 4h10v2H25v-2zm0 4h10v2H25v-2z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M51 21c0 7.44-3.87 13.98-9.71 17.71l-2.7 2.7a2 2 0 0 0-.59 1.42V46a2 2 0 0 1-2 2v1.09a1.5 1.5 0 0 1 0 2.82v1.18a1.5 1.5 0 0 1 0 2.82v.74a2 2 0 0 1-1.26 1.85l-3.56 1.43a1 1 0 0 1-.37.07h-1.62a1 1 0 0 1-.37-.07l-3.56-1.43A2 2 0 0 1 24 56.65v-.74a1.5 1.5 0 0 1 0-2.82V51.9a1.5 1.5 0 0 1 0-2.82V48a2 2 0 0 1-2-2v-3.17a2 2 0 0 0-.59-1.42l-2.7-2.7A21 21 0 1 1 51 21zM34 41.62v-2.04A18.98 18.98 0 0 0 49 21a19 19 0 1 0-23 18.58v2.04c-.83-.16-1.65-.37-2.45-.63a4 4 0 0 1 .45 1.84V46h4v-5l-6-23h3v1h-1.7l4.8 18.4a2 2 0 0 1 .9-1.13V30h-1a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2h-1v6.27a2 2 0 0 1 .9 1.13L36.7 19H35v-1h3l-6 23v5h4v-3.17a4 4 0 0 1 .45-1.84c-.8.26-1.62.47-2.45.63zM31 41v-3a1 1 0 0 0-.5-.87l-.5-.29-.5.3a1 1 0 0 0-.5.86v8h2v-5zm3 12v-1h-8v1h8zm-8 3v.65L29.39 58h1.22L34 56.65V56h-8zm0-7h8v-1h-8v1zm-2 1.5c0 .28.22.5.5.5h11a.5.5 0 0 0 0-1h-11a.5.5 0 0 0-.5.5zm0 4c0 .28.22.5.5.5h11a.5.5 0 0 0 0-1h-11a.5.5 0 0 0-.5.5zm2.67-35.27c-.2.1-.43.14-.67.14v-1c.08 0 .17-.01.22-.04l1.11-.56c.39-.19.95-.19 1.34 0l1.11.56c.1.05.34.05.44 0l1.11-.56c.39-.19.95-.19 1.34 0l1.11.56c.05.03.14.04.22.04v1c-.24 0-.47-.05-.67-.14l-1.11-.56a.64.64 0 0 0-.44 0l-1.11.56c-.39.19-.95.19-1.34 0l-1.11-.56a.64.64 0 0 0-.44 0l-1.11.56zM13 21A17 17 0 0 1 30 4v1a16 16 0 0 0-14.31 23.16l-.9.44A16.93 16.93 0 0 1 13 21z"
    ></path>
  </svg>
</template>
